import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { SupportList } from '@/features/support/SupportList'
import SupportListPagenation from '@/features/support/SupportListPagenation'
import STYLE_GUIDE from '@/shared/constants/styleGuide'
import { useGetNotices } from '@/shared/hooks'

const NoticeListPage = () => {
  const { data } = useGetNotices()
  const pageSize = 5
  const [total, setTotal] = useState(0)
  const [currentPages, setCurrentPages] = useState(5)

  const handlePageSize = () => {
    if (currentPages < total) {
      setCurrentPages((cur) => (cur += pageSize))
    }
  }

  useEffect(() => {
    if (data != null) {
      setTotal(data.length)
    }
  }, [data])

  return (
    <SupportList.SupportListContainer>
      <SupportList.SupportListUl>
        {data != null
          ? data.slice(0, currentPages).map((notice) => (
              <SupportList.SupportListLi key={notice.Idx}>
                <NoticeTitle to={`/noticeDetail/${notice.Idx}`}>{notice.Title}</NoticeTitle>
                <SupportList.SupportListLiDate>
                  {dayjs(notice.RegDT).format('YYYY.MM.DD')}
                </SupportList.SupportListLiDate>
              </SupportList.SupportListLi>
            ))
          : ''}
      </SupportList.SupportListUl>
      <SupportListPagenation
        currentPages={currentPages}
        total={total}
        handlePageSize={handlePageSize}
      />
    </SupportList.SupportListContainer>
  )
}

export default NoticeListPage

const NoticeTitle = styled(NavLink)`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.025em;
    text-align: left;
    padding-inline-start: 5px;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    width: 210px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.025em;
    text-align: left;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
